import { Flex, Button } from '@radix-ui/themes';
import { Link, useLocation } from 'react-router-dom';

function Navigation() {
    const { pathname } = useLocation();

    return (
        <Flex asChild justify="center" align="center" px="5" style={{ height: 100, backgroundColor: 'transparent' }}>
            <header>
                <Flex justify="between" align="center" style={{ maxWidth: 1536, width: '100%' }}>
                    <a href="#" className="p-1">
                        <span className="sr-only">Dylan Graphics</span>
                        <img alt="" src="/images/logo.png" className="h-20 w-auto" />
                    </a>
                    <Flex>
                        <Button
                            asChild
                            variant="ghost"
                            color="gray"
                            highContrast
                            style={{
                                margin: 0,
                                height: 100,
                                fontSize: 24,
                                fontWeight: 500,
                                borderLeft: '3px solid #ffffff',
                                borderRadius: 0,
                                padding: '0 16px',
                                color: '#ffffff',
                                backgroundColor:
                                    pathname === '/' || pathname.startsWith('/portfolio')
                                        ? '#000000'
                                        : 'transparent',
                            }}
                        >
                            <Link to="portfolio">PORTFOLIO</Link>
                        </Button>
                        <Button
                            asChild
                            variant="ghost"
                            color="gray"
                            highContrast
                            style={{
                                margin: 0,
                                height: 100,
                                fontSize: 24,
                                fontWeight: 500,
                                borderLeft: '3px solid #ffffff',
                                borderRight: '3px solid #ffffff',
                                borderRadius: 0,
                                padding: '0 16px',
                                color: '#ffffff',
                                backgroundColor: pathname === '/about' ? '#000000' : 'transparent',
                            }}
                        >
                            <Link to="about">ABOUT</Link>
                        </Button>
                    </Flex>
                </Flex>
            </header>
        </Flex>
    );
}

export default Navigation;
